/* eslint-disable */
import { REHYDRATE } from 'redux-persist';
import { SIDEBAR_PERSIST_KEY } from '../../../Constants/Sidebar/Sidebar.constants';
import { THEME_BREAKPOINT_SM_STEP } from '../../../Constants/Theme/Theme.constants';
import themeStepUp from '../../../Support/Theme/StepUp/ThemeStepUp.support';
import { SIDEBAR_CLOSE, SIDEBAR_OPEN, SIDEBAR_RIGHT_CLOSE, SIDEBAR_RIGHT_OPEN, SIDEBAR_RIGHT_TOGGLE, SIDEBAR_TOGGLE } from './Sidebar.types';

/** @typedef {{ open: boolean }} State */
/** @typedef {ActionAny} SidebarActions */

/**
 * Create the state for the `sidebarReducer` before `redux-persist` kicks in
 * @param {Entry} entry The entry that is currently being used
 * @returns {State} The initial state before `redux-persist` kicks in
 */
const createPrePersistSidebarState = (entry) => ({
  openleft: themeStepUp(entry.breakpoints, THEME_BREAKPOINT_SM_STEP),
  openright: themeStepUp(entry.breakpoints, THEME_BREAKPOINT_SM_STEP),
});

/**
 * Create the `sidebarReducer`
 * @param {InjectablesForReducer} injectables The _injectable_'s required by this reducer
 * @returns {Reducer<State, SidebarActions>} The `sidebarReducer`
 */
const sidebarReducer = ({ entry }) => (state = createPrePersistSidebarState(entry), action) => {
  switch (action.type) {
    case REHYDRATE: {
      if (action.key !== SIDEBAR_PERSIST_KEY || action.payload == null) {
        return state;
      }
      const { _persist, ...newState } = action.payload;
      return newState;
    }
    case SIDEBAR_CLOSE: {
      return {
        ...state,
        openleft: false,
      };
    }
    case SIDEBAR_OPEN: {
      return {
        ...state,
        openleft: true,
      };
    }
    case SIDEBAR_TOGGLE: {
      return {
        ...state,
        openleft: !state.openleft,
      };
    }
    case SIDEBAR_RIGHT_CLOSE: {
      return {
        ...state,
        openright: false,
      };
    }
    case SIDEBAR_RIGHT_OPEN: {
      return {
        ...state,
        openright: true,
      };
    }
    case SIDEBAR_RIGHT_TOGGLE: {
      return {
        ...state,
        openright: !state.openright,
      };
    }
    default: {
      return state;
    }
  }
};

export default sidebarReducer;
